import { render } from "preact"
import { BaseComponent } from "utils/base-component"
import { Modal } from "./modal"
import { Incentive as IncentiveApp } from "../incentive/Incentive"
import { Screens } from "./services/screens"

const subscriptionManagementPath = "/profile/subscription"

export class SignUp extends BaseComponent {
  static cssClass = "js-signup"

  init() {
    // mount the incentive paywall in all .js-incentive elements
    const incentiveEls = document.querySelectorAll(".js-incentive")
    incentiveEls.forEach((el) => {
      el.replaceChildren("")
      this.renderIncentive(el)
    })

    // mount the subscribe paywall in all .js-subscribe elements
    const subscribeEls = document.querySelectorAll(".js-subscribe")
    subscribeEls.forEach((el) => {
      el.replaceChildren("")
      this.renderSubscribe(el, Screens.SignUpScreen)
    })

    // handle premium modal triggers
    const premiumEls = document.querySelectorAll(".js-premium-modal, .js-sign-up-no-free")
    premiumEls.forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault()
        this.openPremiumModal(el)
      })
    })

    // handle signup modal triggers
    const signUpEls = document.querySelectorAll(".js-signup-modal")
    signUpEls.forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault()
        this.mountModal(Screens.SignUpScreen)
      })
    })

    // handle login modal triggers
    const signInEls = document.querySelectorAll(".js-login-modal")
    signInEls.forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault()
        this.mountModal(Screens.SignInScreen)
      })
    })

    // handle email verify modal
    const emailVerifyEls = document.querySelectorAll(".js-email-verify-modal")
    emailVerifyEls.forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault()
        this.mountModal(Screens.EmailVerifyScreen)
      })
    })
  }

  private renderIncentive(el: Element): void {
    render(
      <IncentiveApp
        onReload={() => window.location.reload()}
        // Pass a callback so the paywall can open the modal
        onOpenModal={(page = Screens.SignUpScreen) => this.mountModal(page)}
      />,
      el,
    )
  }

  private openPremiumModal(el: Element): void {
    if ((el as HTMLElement).dataset.paymentProblem === "true") {
      window.location.assign(subscriptionManagementPath)
      return
    }

    this.mountModal(Screens.PaymentScreen)
  }

  // eslint-disable-next-line class-methods-use-this
  private renderSubscribe(el: Element, page = Screens.SignUpScreen): void {
    render(
      <Modal
        action={page}
        source="incentive"
        variant="page"
        onReload={() => window.location.reload()}
      />,
      el,
    )
  }

  private mountModal(page = Screens.SignUpScreen): void {
    render(
      <Modal
        action={page}
        source="incentive"
        onClose={() => this.closeModal()}
        onReload={() => window.location.reload()}
      />,
      this.root,
    )
    document.body.style.setProperty("overflow", "hidden")
    document.body.appendChild(this.root)
  }

  private closeModal(): void {
    render(null, this.root)
    document.body.style.removeProperty("overflow")
    document.body.removeChild(this.root)
  }
}
